// All regex expression can add in this file

/* Phone format with prefix zero number */
const phonePrefixZero = /^0?[1-9][0-9]{6,14}|$/

/* Phone format with prefix zero and 62 number */
const phonePrefixZeroAndLocal = /^(0|62)[0-9]{8,13}$/

/* Cannot contain white space and special character */
const noWhiteSpaceAndSpecialChar = /^[a-zA-Z0-9]+$/

/* Cannot contain special character */
const noSpecialChar = /^[A-Za-z0-9\s]+$/

/* Cannot use space prefix */
const notPrefixSpace = /^(?!\s+|$)/
// const notPrefixSpace = /^\S.*[a-zA-Z0-9\s]*$/

/* Cannot use space prefix but can accept null */
const notPrefixSpaceButCanNull = /^(?!\s+|$).*$|^$/

/* Cannot use space character */
const notSpaceChar = /^\S*$/

/* Cannot use space as the first character */
const notSpaceInFirstChar = /^\S.*[a-zA-Z0-9\s]*|$/

/* Cannot contain white space and special character except dash or underscore  */
const notOnlySpecialChar = /^[A-Za-z0-9_-]+$/

/* Cannot contain white space and special character except dash, dot or underscore  */
const notOnlySpecialCharWithDot = /^[A-Za-z0-9._-]+$/

const rgxExp = {
  phonePrefixZero,
  noWhiteSpaceAndSpecialChar,
  notPrefixSpace,
  notSpaceChar,
  notSpaceInFirstChar,
  noSpecialChar,
  notOnlySpecialChar,
  notOnlySpecialCharWithDot,
  phonePrefixZeroAndLocal,
  notPrefixSpaceButCanNull
}

export default rgxExp
